// Relative to the `/services` base URL used by both web and mobile
export const NP_AVAILABLE_TIMES_PATH = '/v2/calendar/available-times'
export const getNpScheduleSessionsPath = (userLyraId: string) => `/v2/calendar/${userLyraId}/schedule-sessions`
